import React from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import EmployeeSelect from '@/components/Form/Shared/EmployeeSelect'
import UserGroupIcons from '@/icons/UserGroupIcons'
import SectionHeader from '../section-header'
import { CreateTicketFormValues } from '../types'
import { DEPARTMENT_IDS } from '@/constants/departments'

interface AssigneesSectionProps {
    control: Control<CreateTicketFormValues>
}

const AssigneesSection: React.FC<AssigneesSectionProps> = ({ control }) => {
    const { t } = useTranslation()

    return (
        <div className="bg-white rounded-md p-4 border border-gray-100">
            <SectionHeader
                title={t('ticket-assignees')}
                icon={<UserGroupIcons className="w-4 h-4" />}
            />
            <div className="space-y-3">
                <div data-tour="ticket-cs-assignees">
                    <EmployeeSelect
                        label={t('ticket-cs-assignees')}
                        control={control}
                        name="ticket_cs_assignees"
                        multiple
                        showLabel
                        onlyActive
                        departmentIds={[DEPARTMENT_IDS.ACCOUNT]}
                    />
                </div>
                <div data-tour="ticket-sale-assignees">
                    <EmployeeSelect
                        label={t('ticket-sale-assignees')}
                        control={control}
                        name="ticket_sale_assignees"
                        multiple
                        showLabel
                        onlyActive
                        departmentIds={[DEPARTMENT_IDS.SALES]}
                    />
                </div>
                <div data-tour="ticket-technical-assignees">
                    <EmployeeSelect
                        label={t('ticket-technical-assignees')}
                        control={control}
                        name="ticket_technical_assignees"
                        multiple
                        showLabel
                        onlyActive
                        departmentIds={[DEPARTMENT_IDS.TECHNOLOGY]}
                    />
                    <p className="text-xs text-gray-500 mt-1 italic">
                        {t('ticket-technical-assignees-hint')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default AssigneesSection
